import { render, staticRenderFns } from "./IntegrationDetail.vue?vue&type=template&id=0a9c5e00"
import script from "./IntegrationDetail.vue?vue&type=script&lang=js"
export * from "./IntegrationDetail.vue?vue&type=script&lang=js"
import style0 from "./IntegrationDetail.vue?vue&type=style&index=0&id=0a9c5e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports